export default {
  id: 188,
  title: 'Target #188 - Icecream Sticks',
  url: 'https://cssbattle.dev/play/188',
  colors: ['#FFFD9B', '#969610', '#646521'],
  solution:
    '<p a><p b><p c><p d><p e><p f><style>body{background:#fffd9b;margin:0}p{position:fixed;border-radius:1in}p[a],p[b],p[c],p[d]{background:#969610}p[e],p[f]{background:#646521}p[a],p[b],p[e]{width:20;height:240;top:14}p[a]{left:110}p[b]{right:110}p[e]{left:190}p[c],p[d],p[f]{width:340;height:20;left:30}p[c]{top:44}p[d]{bottom:44}p[f]{top:124',
}
